<template>
  <div class="base-divider">
    <span>{{text}}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "baseDivider",
  props: {
    text: {
      type: String,
      default: '基本信息'
    }
  }
}
</script>

<style lang="less" scoped>
  .base-divider {
    margin: 15px 0;
    border-bottom: 1px solid #eee;
    position: relative;
    span {
      display: inline-block;
      width: 80px;
      padding: 10px 0 5px;
      text-align: center;
      border-bottom: 2px solid #1399DC;
      font-size: 14px;
      color: #1399DC;
    }
  }
</style>